import {
  IAccount,
  ProductType,
  ServiceType,
} from "@origin-digital/event-dispatcher";
import { BackendCrm } from "@origin-digital/platform-enums";

const PRODUCT_TO_SERVICE_TYPE: Record<ProductType, ServiceType> = {
  // ELECTRICITY
  [ProductType.ELECTRICITY]: ServiceType.ELECTRICITY,
  [ProductType.CES_ELECTRICITY_APPLIANCE]: ServiceType.ELECTRICITY,
  [ProductType.UNMETERED_ELECTRICITY]: ServiceType.ELECTRICITY,
  [ProductType.CES_ELECTRICITY]: ServiceType.ELECTRICITY,
  // NATURAL_GAS
  [ProductType.GAS]: ServiceType.NATURAL_GAS,
  [ProductType.CES_GAS_APPLIANCE]: ServiceType.NATURAL_GAS,
  [ProductType.UNMETERED_GAS]: ServiceType.NATURAL_GAS,
  // HOT_WATER
  [ProductType.HOT_WATER]: ServiceType.HOT_WATER,
  // BROADBAND
  [ProductType.NBN]: ServiceType.BROADBAND,
  [ProductType.OPTICOMM]: ServiceType.BROADBAND,
  [ProductType.VOIP]: ServiceType.BROADBAND,
  // LPG
  [ProductType.LPG_EXCHANGE]: ServiceType.LPG,
  [ProductType.LPG_INSITU]: ServiceType.LPG, // has usage
  [ProductType.LPG_METERED]: ServiceType.LPG, // has usage
  [ProductType.LPG_INSITU_METERED]: ServiceType.LPG,
  [ProductType.LPG_EXCHANGE_METERED]: ServiceType.LPG,
  [ProductType.LPG_TERMINAL]: ServiceType.LPG,
  // OHM
  [ProductType.OHM]: ServiceType.OHM,
  // VPP_BATTERY
  [ProductType.VPP_BATTERY]: ServiceType.VPP_BATTERY,
  // All other values default to UNKNOWN
  [ProductType.SOLAR]: ServiceType.UNKNOWN,
  [ProductType.SOLAR_PPA]: ServiceType.UNKNOWN,
  [ProductType.EV_CHARGER]: ServiceType.UNKNOWN,
  [ProductType.LPG_PENDING]: ServiceType.UNKNOWN,
  [ProductType.MSP]: ServiceType.UNKNOWN,
  [ProductType.CES_GAS]: ServiceType.UNKNOWN,
  [ProductType.C_AND_I]: ServiceType.UNKNOWN,
  [ProductType.COMMUNITY_BATTERY]: ServiceType.UNKNOWN,
  [ProductType.ESAAS]: ServiceType.UNKNOWN,
  [ProductType.SOLAR_LEAD]: ServiceType.UNKNOWN,
  [ProductType.SOLAR_BATTERY_LEAD]: ServiceType.UNKNOWN,
  [ProductType.BATTERY_LEAD]: ServiceType.UNKNOWN,
  [ProductType.UNKNOWN]: ServiceType.UNKNOWN,
};

const BACKEND_TO_SERVICE_TYPE: Record<BackendCrm, ServiceType> = {
  [BackendCrm.LPG]: ServiceType.LPG,
  [BackendCrm.BROADBAND]: ServiceType.BROADBAND,
  [BackendCrm.VPP]: ServiceType.VPP_BATTERY,
  [BackendCrm.OHM]: ServiceType.OHM,
  // All other values default to UNKNOWN
  [BackendCrm.KRAKEN]: ServiceType.UNKNOWN,
  [BackendCrm.MSP]: ServiceType.UNKNOWN,
  [BackendCrm.ELECTRIFY]: ServiceType.UNKNOWN,
  [BackendCrm.SUPERLOOP]: ServiceType.UNKNOWN,
  [BackendCrm.C_AND_I]: ServiceType.UNKNOWN,
  [BackendCrm.UNKNOWN]: ServiceType.UNKNOWN,
};

/**
 * Map productType to serviceType, if not found then use the backendType to map if possible.
 */
export const mapServiceType = (account: IAccount): ServiceType => {
  if (
    account.services.some(
      (service) => service.productType === ProductType.HOT_WATER
    )
  ) {
    return ServiceType.HOT_WATER;
  }
  const service = account.services?.[0];
  const productTypeMapping =
    PRODUCT_TO_SERVICE_TYPE[service.productType] ?? ServiceType.UNKNOWN;
  return productTypeMapping === ServiceType.UNKNOWN
    ? BACKEND_TO_SERVICE_TYPE[account.backend] ?? ServiceType.UNKNOWN
    : productTypeMapping;
};
